<div class="flex items-center gap-2 pl-4 border-b border-neutral-100 h-10">
  <div class="flex min-w-0 grow content-center">
    <ng-content select="[flxExpandPanelHeader]"></ng-content>
  </div>
  <!-- Right-aligned header zone, so a host can fill the two sides of the row independently. -->
  <div class="flex items-center gap-2 grow-0 shrink-0">
    <ng-content select="[flxBottomPanelActions]"></ng-content>
  </div>
  @if (showToggleButtons()) {
    <div class="flex content-center h-full grow-0 shrink-0">
      <button
        [disabled]="size() === panelSize.SMALL"
        (click)="onPanelMinify()"
        flxButton
        icon="center"
        variant="text"
        data-testid="expandable-panel-minify"
      >
        <flx-icon
          name="caret-down"
          class="w-4 h-4"
        ></flx-icon>
      </button>
      <button
        [disabled]="atMaxSize()"
        (click)="onPanelExpand()"
        flxButton
        icon="center"
        variant="text"
        data-testid="expandable-panel-expand"
      >
        <flx-icon
          name="caret-down"
          class="w-4 h-4 rotate-180"
        ></flx-icon>
      </button>
    </div>
  }
</div>
<div class="flex flex-col grow flex-1 min-h-0 h-full">
  <ng-content></ng-content>
</div>
